<div class="portal--main">
    <div class="module-wrapper">
        <div class="dash-grid">
            <div class="dash-grid--item full-width module drop-shadow bottom">
                <div class="dashboard--module-header">
                    <h2 class="subheading-md">Select interaction type <button class="info-btn focus-element" (click)="onTitleInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                </div>
                <div class="module--main module--main__column">
                    <div class="c-nav--secondary-wrapper">
                        <div class="c-nav--secondary btn-group">
                            <a class="std-btn focus-element subnav-btn active" *ngFor="let navItem of navigationList" [ngClass]="{'active': selectedNavItem == navItem.key}" (click)="changeNavItem(navItem.key)"><span class="focus--content" tabindex="-1">{{navItem.label}}</span></a>
                        </div>
                    </div>
                    <div class="btn-group btn-group__stacked u-spacing--large">
                        <button class="std-btn outline focus-element" [ngClass]="{'outline--active': items.selected }" *ngFor="let items of OptionItemList" (click)="clickOptionitem(items)">
                            <span class="focus--content" tabindex="-1">{{items.key}}</span>
                        </button>
                    </div>
                    <form class="form-group form-group__medium" [formGroup]="form" autocomplete="off" novalidate>
                        <label for="bit">Multi-device interaction tag <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></label>
                        <div class="input-addon input-addon__std right">
                            <input type="text" id="bit" maxlength="25" [formControl]="form.controls['bulkInteractionTag']" class="input-addon__std--input">
                            <span class="input-addon__std--text-overlay">{{interactionTagLength}}/25</span>
                        </div>
                        <div class="form-group danger" *ngIf="submitted">
                            <span *ngIf="form.controls['bulkInteractionTag'].hasError('required')" class="validation-msg">Bulk Tag is required*</span>
                        </div>
                    </form>
                    <button class="std-btn focus-element" (click)="submit(form)"><span class="focus--content" tabindex="-1">Next</span></button>
                </div>
            </div>
        </div>
    </div>
</div>
